import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface RearLeftUpperControlArmProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function RearLeftUpperControlArm(props: RearLeftUpperControlArmProps) {
  return (
    <svg
      width="66"
      height="48"
      viewBox="0 0 66 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{right: 269, bottom: 86}}
      onClick={props.onClick}
    >
      <path
        d="M37.0001 47V40.3145C41.6604 38.6669 45.0001 34.2246 45.0001 29C45.0001 27.0438 44.5316 25.1971 43.7013 23.5654L63.0001 1H53.0001L38.0001 18.0879C36.4238 17.3265 34.868 17 33.0001 17C31.2157 17 29.5222 17.3893 28.0001 18.0879L13.0001 1H3.00012L22.2697 23.6221C21.4574 25.2396 21.0001 27.0666 21.0001 29C21.0001 34.2246 24.3398 38.6669 29.0001 40.3145V47H37.0001Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M37.0001 41V47H29.0001V41"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M53.0001 1.00032L38.0001 18.0882C36.4237 17.3268 34.8681 17 33.0001 17C31.2157 17 29.5222 17.3895 28.0001 18.0881L13.0001 1.00021L3.00012 1L22.2696 23.6224C21.4573 25.24 21.0001 27.0666 21.0001 29C21.0001 35.6274 26.3727 41 33.0001 41C39.6275 41 45.0001 35.6274 45.0001 29C45.0001 27.0438 44.532 25.1969 43.7017 23.5652L63.0001 1.00032H53.0001Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M41.0001 29L37.0001 22.0718L29.0001 22.0718L25.0001 29L29.0001 35.9282L37.0001 35.9282L41.0001 29Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="4"
        cy="4"
        r="4"
        transform="matrix(1 0 0 -1 29.0001 33)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </svg>
  );
}
